<template>
  <div>
    <div class="d-flex justify-center">
      <table-pagination-controls
        :total-rows="vehicleViolations.length"
        :current-page.sync="currentPage"
        :rows-per-page.sync="rowsPerPage"
        :per-page-options="pageOptions"
      />
    </div>
    <v-data-table
      dense
      hide-default-footer
      class="vf-table mt-2 mb-6"
      :items="vehicleViolations"
      :headers="tableFields"
      :page="currentPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :items-per-page="rowsPerPage">
      <template v-slot:item.name="row">
        <router-link :to="`/vehicle/${row.item.id}`">
          {{row.value}}
        </router-link>
      </template>
      <template v-slot:item.first_violation="row">
        <multi-time-display :time="row.value" />
      </template>
      <template v-slot:item.last_violation="row">
        <multi-time-display :time="row.value" />
      </template>
      <template v-slot:item.violating_route_count="row">
        <router-link :to="`/route/index?${constructRouteSearchQuery(row.item)}`">
          {{ row.value }}
        </router-link>
      </template>
      <template v-slot:item.percent_violating="row">
        {{row.value.toFixed(0)}}%
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TablePaginationControls from '@/components/shared/TablePaginationControls'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ReportRecord from '@/orm/models/ReportRecord'

import { get } from 'lodash'
import Moment from 'moment-timezone'

export default {
  name: 'VehicleViolationReport',
  components: {
    TablePaginationControls,
    MultiTimeDisplay
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {
      currentPage: 1,
      rowsPerPage: 20,
      sortBy: 'percent_violating',
      sortDesc: true,
      pageOptions: [10, 20, 50, 100, { value: -1, text: this.$t('all') }],
      tableFields: [
        {
          value: 'name',
          text: this.$tc('vehicle', 2),
          sortable: true
        },
        {
          value: 'first_violation',
          text: this.$t('reports_ui.vehicle_violation_report.first_violation'),
          sortable: true
        },
        {
          value: 'last_violation',
          text: this.$t('reports_ui.vehicle_violation_report.last_violation'),
          sortable: true
        },
        {
          value: 'violating_route_count',
          text: this.$t('reports_ui.vehicle_violation_report.violating_routes'),
          sortable: true
        },
        {
          value: 'percent_violating',
          text: this.$t('reports_ui.vehicle_violation_report.percent_violating'),
          sortable: true
        }
      ]
    }
  },
  computed: {
    /**
     * @return array
     */
    vehicleViolations () {
      return Object.values(get(this, 'report.results') || {})
    }
  },
  methods: {
    /**
     * Returns the query portion of an HTTP request to show routes matching the criteria of this report / row selected.
     *
     * We know the total number of routes represented in the report may be larger than will be rendered by following
     * this link because the route index (intentionally) does not include GPS data gaps or missed stops; and
     * this is because we want the no violations drop down in the route index to include routes with warnings (which gps
     * gap and missed stops are). See VF-465, VF-547, and VF-586 for more history here.
     *
     * @return string
     */
    constructRouteSearchQuery (violationRecord) {
      this.report.parameters.violations.join(',')
      const startDate = Moment(this.report.parameters.startDate).tz(this.report.parameters.timezone).format('YYYY-MM-DD')
      const endDate = Moment(this.report.parameters.endDate).tz(this.report.parameters.timezone).format('YYYY-MM-DD')
      const violationsCsv = this.report.parameters.violations.join(',')
      return `vehicleId=${violationRecord.id}&startDate=${startDate}&endDate=${endDate}&violations=${violationsCsv}`
    }
  }
}

</script>
